import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APPCONSTANT } from '../../constants';

@Component({
  selector: 'amm-footer',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './amm-footer.component.html',
  styleUrl: './amm-footer.component.scss',
})
export class AmmFooterComponent {

  private isSmallSize: boolean = window.innerWidth <= APPCONSTANT.SMALL_SIZE_WIDTH;

  @HostListener('window:resize', [])
  onResize(): void {
    this.isSmallSize = window.innerWidth <= APPCONSTANT.SMALL_SIZE_WIDTH;
  }

  getActionClass(): string {
    return this.isSmallSize ? 'flex-col gap-4 items-start' : 'flex-row justify-between';
  }

}
